import { graphql } from 'parkdepot-shared/gql'

export const OrderResponseFragment = graphql(`
    fragment B2COrderResponse on B2CCarpayOrderView {
        order {
            order_id
            plate
            start_date
            end_date
            status
            invoice_available
        }
        lot {
            lot_id
            name
            address
            lot_type
            lot_tariffs
            sv_lot_type
            discount_types
            visible_toleration_time
            arrival_detection_time
        }
        price {
            currency
            vat_rate
            price_valid_until
            parking_price
            illegal_parking_price
            discounted_parking_price
            applied_discount
            billable
            billable_start
            billable_end
            payment_deadline
        }
        parking_contexts {
            uuid
            vehicle_type
        }
        scanned_codes
    }
`)

const B2C_GET_OPEN_ORDERS = graphql(`
    query B2CGetOpenOrders($plates: [String!]!) {
        b2c_get_open_orders(plates: $plates) {
            orders {
                ...B2COrderResponse
            }
        }
    }
`)

export default B2C_GET_OPEN_ORDERS
